import { Injectable, Inject } from '@angular/core';
import { Observable, throwError, of } from "rxjs";
import 'rxjs/add/operator/map';
import 'rxjs/operator';
import 'rxjs/add/operator/catch';
import { HttpClient } from "@angular/common/http";
import { BaseService } from './BaseService';
import { MenuItem } from 'primeng/api';
import { ILockStatus } from '../Models/ILockStatus';
import { IIepInstance } from '../Models/IIepInstance';
import { IInitialIEPInfo } from '../Models/IInitialIEPInfo';
import { IIEPStatusEvent } from '../Models/IIEPStatusEvent';
import { ILookupBase } from '../Models/ILookupBase';
import { IFormDetails } from '../Models/IFormDetails';
import { IProgressReportBasicData } from '../Models/IProgressReportBasicData';


@Injectable()
export class IepService extends BaseService {
  _baseUrl: string = "";
  _status: any;


  constructor(protected _http: HttpClient, @Inject('BASE_URL') baseUrl: string) {
    super(_http);
    this._baseUrl = baseUrl;
  }

  getIepMenuItems(url: string): Observable<MenuItem[]> {
    return this._http.get<MenuItem[]>(url).map((response: MenuItem[]) => response as MenuItem[])
      .catch(this.handleError);
  }

  getPrintIepForms(iepInstanceId: number): Observable<ILookupBase[]> {
    return this._http.get<ILookupBase[]>(this._baseUrl + 'api/Iep/GetPrintIepForms' + iepInstanceId)
      .map((response: ILookupBase[]) => response as ILookupBase[])
      .catch(this.handleError);
  }

  getIepInstance(url: string): Observable<IIepInstance> {
    return this._http.get<IIepInstance>(url).map((response: IIepInstance) => response as IIepInstance)
      .catch(this.handleError);
  }

  getIepStatusEvents(url: string): Observable<IIEPStatusEvent[]> {
    return this._http.get<IIEPStatusEvent[]>(url).map((response: IIEPStatusEvent[]) => response as IIEPStatusEvent[])
      .catch(this.handleError);
  }

  getProgressReportBasicData(iepInstanceId: number): Observable<IProgressReportBasicData[]> {
    return this._http.get<IProgressReportBasicData[]>(this._baseUrl + 'api/Iep/GetProgressReportBasicData' + iepInstanceId)
      .map((response: IProgressReportBasicData[]) => response as IProgressReportBasicData[])
      .catch(this.handleError);
  }

  getProgressReportBasicDataByStudent(localStudentId: string): Observable<IProgressReportBasicData[]> {
    return this._http.get<IProgressReportBasicData[]>(this._baseUrl + `api/Iep/GetProgressReportBasicDataByStudent/${localStudentId}`)
      .map((response: IProgressReportBasicData[]) => response as IProgressReportBasicData[])
      .catch(this.handleError);
  }

  GetSelectedFormDetails(url: string): Observable<IFormDetails> {
    return this._http.get<IFormDetails>(url).map((response: IFormDetails) => response as IFormDetails)
      .catch(this.handleError);
  }

  lockUnlockForm(url: string): Observable<ILockStatus> {
    return this._http.get<ILockStatus>(url).map((response: ILockStatus) => response as ILockStatus)
      .catch(this.handleError);
  }

  getInitialIepInfo(url: string): Observable<IInitialIEPInfo> {
    return this._http.get<IInitialIEPInfo>(url).map((response: IInitialIEPInfo) => response as IInitialIEPInfo)
      .catch(this.handleError);
  }

  insertUpdateIepInstance(iepInstanceDetails: IIepInstance): Observable<IIepInstance> {
    return this._http.post<IIepInstance>(this._baseUrl + 'api/Iep/InsertUpdateIepInstance', iepInstanceDetails)
      .map((response: IIepInstance) => response as IIepInstance)
      .catch(this.handleError);
  }

  conveneMeeting(iepInstanceDetails: IIepInstance): Observable<string[]> {
    return this._http.post<string[]>(this._baseUrl + 'api/Iep/ConveneMeeting', iepInstanceDetails)
      .map((response: string[]) => response as string[])
      .catch(this.handleError);
  }

  validateForms(iepInstanceDetails: IIepInstance): Observable<string[]> {
    return this._http.post<string[]>(this._baseUrl + 'api/Iep/ValidateForms', iepInstanceDetails)
      .map((response: string[]) => response as string[])
      .catch(this.handleError);
  }

  deleteIEPForm(formInstanceId: number): Observable<string> {
    return this._http.delete<string>(this._baseUrl + 'api/Iep/DeleteIEPForm?formInstanceId=' + formInstanceId)
      .map((response: string) => response as string)
      .catch(this.handleError);
  }

  reConveneMeeting(iepInstanceDetails: IIepInstance): Observable<IIepInstance> {
    return this._http.post<IIepInstance>(this._baseUrl + 'api/Iep/ReConveneMeeting', iepInstanceDetails)
      .map((response: IIepInstance) => response as IIepInstance)
      .catch(this.handleError);
  }

  goToPrintSignature(iepInstanceDetails: IIepInstance): Observable<IIepInstance> {
    return this._http.post<IIepInstance>(this._baseUrl + 'api/Iep/GoToPrintSignature', iepInstanceDetails)
      .map((response: IIepInstance) => response as IIepInstance)
      .catch(this.handleError);
  }

  goToOfficial(iepInstanceDetails: IIepInstance): Observable<IIepInstance> {
    return this._http.post<IIepInstance>(this._baseUrl + 'api/Iep/GoToOfficial', iepInstanceDetails)
      .map((response: IIepInstance) => response as IIepInstance)
      .catch(this.handleError);
  }

  goToCancelled(iepInstanceDetails: IIepInstance): Observable<IIepInstance> {
    return this._http.post<IIepInstance>(`${this._baseUrl}api/Iep/GoToCancelled`, iepInstanceDetails)
      .map((response: IIepInstance) => response as IIepInstance)
      .catch(this.handleError);
  }

}
